<!-- Apply Branding(s) to all currently displayed OverlayDataField widgets. -->

<template>
  <!-- No brandings at all: Show nothing -->
  <div>
    <!-- Single default branding: Show a button -->
    <v-btn
      v-if="brandings.length === 1 && !!defaultBranding"
      flat
      round
      class="ma-0"
      :class="{
        'grey--text text--darken-2': !active,
        'msr--text': active,
      }"
      :title="$t('templateDataApplyBranding')"
      @click="applyDefaultBranding()"
    >
      <v-icon left>
        format_paint
      </v-icon>
      {{ $t('templateDataApplyBranding') }}
    </v-btn>
    <!-- In any other case: Show a dropdown -->
    <v-menu
      v-if="brandings.length > 1"
      v-model="menu"
      offset-y
      :title="$t('templateDataApplyBranding')"
      :close-on-content-click="closeOnContentClick"
    >
      <v-btn
        slot="activator"
        flat
        round
        :class="{
          'grey--text text--darken-2': !active,
          'msr--text': active,
        }"
        :title="$t('templateDataApplyBranding')"
        @click="onMenuActivatorClicked($event)"
      >
        <v-icon left>
          format_paint
        </v-icon>
        {{ title || $t('templateDataApplyBranding') }}
        <v-icon right>
          arrow_drop_down
        </v-icon>
      </v-btn>
      <v-list>
        <template v-for="branding in brandings">
          <v-hover :key="'hover-' + branding.id">
            <v-list-tile
              :key="branding.id"
              slot-scope="{hover}"
              @click="applyBranding(branding)"
            >
              <v-list-tile-content :title="$t('templateDataApplyBranding')">
                <v-list-tile-title
                  :class="{
                    'msr--text font-weight-bold':
                      lastBrandingApplied &&
                      lastBrandingApplied.id == branding.id,
                  }"
                >
                  {{ branding.name }}
                </v-list-tile-title>
                <v-list-tile-sub-title
                  v-if="branding.is_default"
                  class="msr--text caption"
                >
                  {{ $t('brandingIsDefault') }}
                </v-list-tile-sub-title>
              </v-list-tile-content>
              <v-list-tile-action :title="$t('brandingDialogTitleEdit')">
                <v-btn
                  v-if="hover"
                  icon
                  color="msr--text"
                  :to="{name: 'branding', query: {edit: branding.id}}"
                  @click.stop
                >
                  <v-icon> edit </v-icon>
                </v-btn>
              </v-list-tile-action>
            </v-list-tile>
          </v-hover>
        </template>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import tvtemplateBrandings from '@/mixins/tvtemplateBrandings.js';

export default {
  mixins: [tvtemplateBrandings],
  props: {
    /**
     * Needed to know about brandable fields.
     */
    overlayOptions: {
      type: Object,
      required: true,
    },
    hideWhenNoBrandableFieldsExist: {
      type: Boolean,
      default: true,
    },
    active: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      menu: false,
      closeOnContentClick: true,
    };
  },
  computed: {
    lastBrandingApplied() {
      return this.$store.state.common.lastBrandingApplied;
    },
  },
  watch: {
    menu: function (menu) {
      // Revert to default behaviour when menu is closed.
      if (!menu && !this.closeOnContentClick) {
        this.closeOnContentClick = true;
      }
    },
  },
  methods: {
    applyDefaultBranding() {
      if (this.defaultBranding) {
        this.applyBranding(this.defaultBranding);
      }
    },
    onMenuActivatorClicked(event) {
      // Do not close menu when selecting items when shift was pressed
      // when clicking the activator button. This helps with testing.
      if (event && event.shiftKey) {
        this.closeOnContentClick = !this.closeOnContentClick;
      }
    },
    applyBranding(branding) {
      const changeset = this.getChangesetToApplyBranding(
        branding,
        this.overlayOptions
      );
      for (let fieldName of Object.keys(changeset)) {
        const newValue = changeset[fieldName];
        // Update the values living in the OverlayDataField widgets.
        this.$bus.$emit('set-overlay-data-field-value', fieldName, newValue);
      }

      const context = {
        branding: branding,
        overlayOptions: this.overlayOptions,
      };
      this.$emit('applied', context);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/TvTemplateBrandingWidget.vue